<div class="report-card">
  <div class="header">
    Customer Issues
    <span class="sub-header">
      As of Today
      @if (employee && !companyWide) {
        <span>, {{employee.fullName}}</span>
      }
      @if (companyWide) {
        <span>, All</span>
      }
    </span>
  </div>
  <app-loading-swirly [isLoading]="issuesLoading"></app-loading-swirly>

  @if (!issuesLoading) {
    <div>
      <div class="big-header" style="text-align: left; margin-bottom: 8px;" [ngClass]="issues.length > 0 ? 'bad-text' : 'good-text' ">
        {{issues.length}}
        <span class="small">
          Active Issue(s)
        </span>
      </div>
      <div>
        <div class="pretend-table-row">
          <span>
            Work Order
          </span>
          <span>
            Date Reported
          </span>
        </div>
        <div class="horizontal-line"></div>
      </div>
      @if (issues.length == 0) {
        <div class="fine-print" style="text-align: center;">
          No active issues!
        </div>
      }
      @for (issue of issues; track issue) {
        <div>
          <div class="pretend-table-row">
            <span>
              <a target="_blank" class="regular-link" (click)="goToWorkOrder(issue)">{{issue.quoteNumber}}</a>
            </span>
            <span>
              {{issue.reportedOn | date: 'shortDate'}}
            </span>
          </div>
          <div class="horizontal-line"></div>
        </div>
      }
    </div>
  }
</div>
